"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Portal = function Portal(_ref) {
  var children = _ref.children,
      domId = _ref.domId;
  var mount = document.querySelectorAll(domId)[0] || document.getElementsByTagName('body')[0]; // const el = document.createElement('div');
  // console.log(mount);
  // useEffect(() => {
  //   mount.appendChild(el);
  //   return () => mount.removeChild(el);
  // }, [el, mount]);

  return /*#__PURE__*/(0, _reactDom.createPortal)(children, mount);
};

Portal.propTypes = {
  children: _propTypes.default.node.isRequired,
  domId: _propTypes.default.string.isRequired
};
var _default = Portal;
exports.default = _default;